(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * Particle
 */

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Particle = function () {
  function Particle(mass, position, velocity) {
    _classCallCheck(this, Particle);

    this.mass = mass;
    this.position = position;
    this.velocity = velocity;
  }

  _createClass(Particle, [{
    key: 'momentum',
    get: function get() {
      return this.velocity.clone().scale(this.mass);
    }
  }]);

  return Particle;
}();

module.exports = Particle;

},{}],2:[function(require,module,exports){
/**
 * Vector
 */

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var util = require('./util');

var Vector = function () {
  function Vector() {
    _classCallCheck(this, Vector);

    this.vector = Array.prototype.slice.call(arguments);
  }

  // Getters:

  _createClass(Vector, [{
    key: 'subtract',


    // Operations:

    value: function subtract(vector) {
      var _this = this;

      util.assert(this.dimension === vector.dimension, 'Vectors must be same dimension to subtract.');
      this.vector.forEach(function (n, i) {
        return _this.vector[i] -= vector.vector[i];
      });
      return this;
    }
  }, {
    key: 'add',
    value: function add(vector) {
      var _this2 = this;

      util.assert(this.dimension === vector.dimension, 'Vectors must be same dimension to add.');
      this.vector.forEach(function (n, i) {
        return _this2.vector[i] += vector.vector[i];
      });
      return this;
    }
  }, {
    key: 'scale',
    value: function scale(_scale) {
      var _this3 = this;

      // TODO preserve direction even if scale 0
      util.assert(_scale, 'Scale must not be 0.');

      this.vector.forEach(function (n, i) {
        return _this3.vector[i] *= _scale;
      });
      return this;
    }
  }, {
    key: 'normalize',
    value: function normalize() {
      return this.scale(1 / this.magnitude);
    }

    // Utils:

  }, {
    key: 'clone',
    value: function clone() {
      return new (Function.prototype.bind.apply(Vector, [null].concat(_toConsumableArray(this.vector))))();
    }
  }, {
    key: 'toString',
    value: function toString() {
      return this.vector.toString();
    }
  }, {
    key: 'dimension',
    get: function get() {
      return this.vector.length;
    }
  }, {
    key: 'magnitude',
    get: function get() {
      return Math.sqrt(this.vector.reduce(function (p, n) {
        return p + n * n;
      }, 0));
    }
  }]);

  return Vector;
}();

module.exports = Vector;

},{"./util":6}],3:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Vector in 2 Dimensions
 */

var Vector = require('./Vector');

var Vector2D = function (_Vector) {
  _inherits(Vector2D, _Vector);

  function Vector2D() {
    _classCallCheck(this, Vector2D);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Vector2D).apply(this, arguments));
  }

  _createClass(Vector2D, [{
    key: 'x',
    get: function get() {
      return this.vector[0];
    }
  }, {
    key: 'y',
    get: function get() {
      return this.vector[1];
    }
  }]);

  return Vector2D;
}(Vector);

;

Vector2D.build = function (magnitude, theta) {
  var x = Math.cos(theta) * magnitude;
  var y = Math.sin(theta) * magnitude;
  return new Vector2D(x, y);
};

module.exports = Vector2D;

},{"./Vector":2}],4:[function(require,module,exports){
'use strict';

var Particle = require('./Particle');
var Vector2D = require('./Vector2D');

// Canvas setup:

var canvas = document.createElement('canvas');
var ctx = canvas.getContext("2d");
var height = canvas.height = window.innerHeight;
var width = canvas.width = window.innerWidth;

document.body.appendChild(canvas);

var TIME = 1000 / (365 * 24 * 60 * 60 / 16); // 1 Second = 1 Year
var GAMMA = 6.674e-11; // Gravitational constant
var SOLAR_MASS = 1.989e30;

//
// Instances:
//

var velocity = new Vector2D.build(0, Math.PI * 1.25);
var position = new Vector2D(0, 0);
var particle = new Particle(SOLAR_MASS, position, velocity);

var planets = require('./planets.json');
var _particles = [particle];

planets.forEach(function (planet) {
  var velocity = Vector2D.build(planet.velocity, Math.PI * 0.5);
  var position = Vector2D.build(planet.distance, 0);
  _particles.push(new Particle(planet.mass, position, velocity));
});

var transform = {
  width: width,
  height: height,
  x: function x(_x) {
    return this.width / 2 + _x / 5e9;
  },
  y: function y(_y) {
    return this.height / 2 - _y / 5e9;
  }
};

var draw = {
  ctx: ctx,
  init: function init() {
    this.ctx.translate(0.5, 0.5);
    this.previousTime = this.now();
    this.start = this.now();
  },
  particles: function particles() {

    var ctx = this.ctx;
    var deltaT = this.deltaT;
    var period = deltaT / TIME;

    // Forces on each particle:
    var forces = _particles.map(function (particleA) {
      return _particles.reduce(function (p, particleB) {
        if (particleA === particleB) return p;
        var difference = particleB.position.clone().subtract(particleA.position.clone());
        var distance = difference.magnitude;
        var force = difference.normalize().scale(GAMMA * particleA.mass * particleB.mass / (distance * distance));
        return p.add(force);
      }, new Vector2D(0, 0)); // TODO not 2D
    });

    _particles.forEach(function (particle, i) {

      // Calculate acceleration:
      var force = forces[i];
      var acceleration = force.clone().scale(period / particle.mass); // a_t = F_t/m

      // Adjust velocity:
      particle.velocity.add(acceleration);

      // Adjust position:
      particle.position.add(particle.velocity.clone().scale(period));

      // Draw particles:
      ctx.beginPath();
      ctx.fillStyle = 'blue';
      ctx.arc(transform.x(particle.position.x), transform.y(particle.position.y), 3, 0, 2 * Math.PI, false);
      ctx.closePath();
      ctx.fill();
    });
  },
  coordinates: function coordinates() {

    var ctx = this.ctx;

    // Diagonals:
    ctx.beginPath();
    ctx.strokeStyle = '#ddd';
    ctx.moveTo(0, 0);
    ctx.lineTo(width, height);
    ctx.moveTo(0, height);
    ctx.lineTo(width, 0);
    ctx.moveTo(0, 0);
    ctx.closePath();
    ctx.stroke();

    // Horizontals::
    ctx.beginPath();
    ctx.strokeStyle = '#bbb';
    ctx.moveTo(0, height / 2);
    ctx.lineTo(width, height / 2);
    ctx.moveTo(width / 2, 0);
    ctx.lineTo(width / 2, height);
    ctx.moveTo(0, height / 2);
    ctx.closePath();
    ctx.stroke();
  },
  clear: function clear() {
    canvas.width = width;
    canvas.height = height;
  },
  now: function now() {
    return +new Date();
  },
  run: function run() {
    var draw = this;
    function loop() {
      setTimeout(function () {
        draw.tick(loop);
      }, 5);
    }
    loop();
  },
  tick: function tick(cb) {
    var draw = this;
    window.requestAnimationFrame(function () {
      draw.deltaT = draw.now() - draw.previousTime;
      draw.clear();
      draw.coordinates();
      draw.particles();
      draw.previousTime = draw.now();
      cb && cb();
    });
  }
};

draw.init();
draw.run();

},{"./Particle":1,"./Vector2D":3,"./planets.json":5}],5:[function(require,module,exports){
module.exports=[
  {
    "name": "MERCURY",
    "mass": 3.3000000000000004e+24,
    "velocity": 47400,
    "distance": 57900000000
  },
  {
    "name": "VENUS",
    "mass": 4.8700000000000005e+25,
    "velocity": 35000,
    "distance": 108200000000
  },
  {
    "name": "EARTH",
    "mass": 5.9700000000000005e+25,
    "velocity": 29800,
    "distance":149600000000
  },
  {
    "name": "MARS",
    "mass": 6.420000000000001e+24,
    "velocity": 24100,
    "distance": 227900000000
  },
  {
    "name": "JUPITER",
    "mass": 1.8980000000000002e+28,
    "velocity": 13100,
    "distance": 778600000000
  },
  {
    "name": "SATURN",
    "mass": 5.680000000000001e+27,
    "velocity": 9700,
    "distance": 1433500000000
  },
  {
    "name": "URANUS",
    "mass": 8.68e+26,
    "velocity": 6800,
    "distance": 2872500000000
  },
  {
    "name": "NEPTUNE",
    "mass": 1.0200000000000001e+27,
    "velocity": 5400,
    "distance": 4495100000000
  },
  {
    "name": "PLUTO",
    "mass": 1.4600000000000001e+23,
    "velocity": 4700,
    "distance": 5906400000000
  }
]

},{}],6:[function(require,module,exports){
/**
 * Utils.
 */

'use strict';

module.exports = {
  assert: function assert(value, message) {
    if (!value) throw new Error(message);
  }
};

},{}]},{},[4])

